import { render } from "./AdminBoxViewers.vue?vue&type=template&id=5e7df456&scoped=true"
import script from "./AdminBoxViewers.vue?vue&type=script&lang=js"
export * from "./AdminBoxViewers.vue?vue&type=script&lang=js"

import "./AdminBoxViewers.vue?vue&type=style&index=0&id=5e7df456&scoped=true&lang=sass"

import exportComponent from "/home/ploi/orthomatrix.orthosol.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e7df456"]])

export default __exports__